import getEANs from './getEANs';
import getCopyAndPaste from './getCopyAndPaste';

window.getEANs = getEANs;
window.getCopyAndPaste = getCopyAndPaste;
